import * as actionTypes from './../Global_action.types';
import * as api from './../global_api_services/ActRuleActivity.api';


export const uploadActRequest = (fileData) => ({
    type: actionTypes.UPLOAD_ACT_REQUEST,
    payload: fileData,
  });
  
  export const uploadActSuccess = (fileData) => ({
    type: actionTypes.UPLOAD_ACT_SUCCESS,
    payload: fileData,
  });
  
  export const uploadActFailure = (error) => ({
    type: actionTypes.UPLOAD_ACT_FAILURE,
    payload: error,
  });
  
  export const uploadActFile = (fileData) => {
    return async (dispatch) => {
      dispatch(uploadActRequest(fileData));
      try {
        const response = await api.uploadAct(fileData);
        dispatch(uploadActSuccess(response));
        return { success: true, data: response };
      } catch (error) {
        dispatch(uploadActFailure(error));
      const errorMessage = error?.response?.data?.error || error?.message || 'Upload failed';
      return { success: false, error: errorMessage };
      }
    };
  };
  export const multiDaleteActRequest = (ids) => ({
    type: actionTypes.MULTIDELETE_ACT_REQUEST,
    payload: ids,
  });
  
  export const multiDaleteActSuccess = (message) => ({
    type: actionTypes.MULTIDELETE_ACT_SUCCESS,
    payload: message,
  });
  
  export const multiDaleteActFailure = (error) => ({
    type: actionTypes.MULTIDELETE_ACT_FAILURE,
    payload: error,
  });
  
  export const multiDeleteActFile = (ids) => {
    return async (dispatch) => {
      dispatch(multiDaleteActRequest(ids));
      try {
        const response = await api.multiDeleteAct(ids);
        dispatch(multiDaleteActSuccess(response));
        return { success: true, message: response };
      } catch (error) {
        dispatch(multiDaleteActFailure(error));
        return { success: false, message: error };
      }
    };
  };
  
  
  export const getActRequest = () => ({
    type: actionTypes.GET_ACT_REQUEST,
  });
  
  export const getActSuccess = (clients) => ({
    type: actionTypes.GET_ACT_SUCCESS,
    payload: clients,
  });
  
  export const getActFailure = (error) => ({
    type: actionTypes.GET_ACT_FAILURE,
    payload: error,
  });
  
  export const getAct = () => {
    return async (dispatch) => {
      dispatch(getActRequest());
      try {
        const response = await api.fetchAct();
        dispatch(getActSuccess(response));
        return { success: true, data: response };
      } catch (error) {
        dispatch(getActFailure(error));
        return { success: false, message: error };
      }
    };
  };
  
  export const updateActRequest = (id, clientData) => ({
    type: actionTypes.UPDATE_ACT_REQUEST,
    payload: { id, clientData },
  });
  
  export const updateActSuccess = (message) => ({
    type: actionTypes.UPDATE_ACT_SUCCESS,
    payload: message,
  });
  
  export const updateActFailure = (error) => ({
    type: actionTypes.UPDATE_ACT_FAILURE,
    payload: error,
  });
  
  export const updateActById = (id, salaryData) => {
    return async (dispatch) => {
      const user = JSON.parse(sessionStorage.getItem('user'));
      salaryData.updated_by = user.user_name;
  
      dispatch(updateActRequest(id, salaryData));
      try {
        const response = await api.updateAct(id, salaryData);
        dispatch(updateActSuccess(response.message));
        return { success: true, message: response.message };
      } catch (error) {
        dispatch(updateActFailure(error));
        return { success: false, message: error };
      }
    };
  };
  export const deleteActRequest = (id) => ({
    type: actionTypes.DELETE_ACT_REQUEST,
    payload: id,
  });
  
  export const deleteActSuccess = (message) => ({
    type: actionTypes.DELETE_ACT_SUCCESS,
    payload: message,
  });
  
  export const deleteActFailure = (error) => ({
    type: actionTypes.DELETE_ACT_FAILURE,
    payload: error,
  });
  
  export const deleteActById = (id) => {
    return async (dispatch) => {
      dispatch(deleteActRequest(id));
      try {
        const response = await api.deleteAct(id);
        dispatch(deleteActSuccess(response.message));
        return { success: true, message: response.message };
      } catch (error) {
        dispatch(deleteActFailure(error));
        return { success: false, message: error };
      }
    };
  };


  export const uploadRuleRequest = (fileData) => ({
      type: actionTypes.UPLOAD_RULE_REQUEST,
      payload: fileData,
    });
    
    export const uploadRuleSuccess = (fileData) => ({
      type: actionTypes.UPLOAD_RULE_SUCCESS,
      payload: fileData,
    });
    
    export const uploadRuleFailure = (error) => ({
      type: actionTypes.UPLOAD_RULE_FAILURE,
      payload: error,
    });
    
    export const uploadRuleFile = (fileData) => {
      return async (dispatch) => {
        dispatch(uploadRuleRequest(fileData));
        try {
          const response = await api.uploadRule(fileData);
          dispatch(uploadRuleSuccess(response));
          return { success: true, data: response };
        } catch (error) {
          dispatch(uploadRuleFailure(error));
          const errorMessage = error?.response?.data?.error || error?.message || 'Upload failed';
          return { success: false, error: errorMessage };
        }
      };
    };
    export const multiDaleteRuleRequest = (ids) => ({
      type: actionTypes.MULTIDELETE_RULE_REQUEST,
      payload: ids,
    });
    
    export const multiDaleteRuleSuccess = (message) => ({
      type: actionTypes.MULTIDELETE_RULE_SUCCESS,
      payload: message,
    });
    
    export const multiDaleteRuleFailure = (error) => ({
      type: actionTypes.MULTIDELETE_RULE_FAILURE,
      payload: error,
    });
    
    export const multiDeleteRuleFile = (ids) => {
      return async (dispatch) => {
        dispatch(multiDaleteRuleRequest(ids));
        try {
          const response = await api.multiDeleteRule(ids);
          dispatch(multiDaleteRuleSuccess(response));
          return { success: true, message: response };
        } catch (error) {
          dispatch(multiDaleteRuleFailure(error));
          return { success: false, message: error };
        }
      };
    };
    
    
    export const getRuleRequest = () => ({
      type: actionTypes.GET_RULE_REQUEST,
    });
    
    export const getRuleSuccess = (clients) => ({
      type: actionTypes.GET_RULE_SUCCESS,
      payload: clients,
    });
    
    export const getRuleFailure = (error) => ({
      type: actionTypes.GET_RULE_FAILURE,
      payload: error,
    });
    
    export const getRule = (current_month) => {
      return async (dispatch) => {
        dispatch(getRuleRequest());
        try {
          const response = await api.fetchRule(current_month);
          dispatch(getRuleSuccess(response));
          return { success: true, data: response };
        } catch (error) {
          dispatch(getRuleFailure(error));
          return { success: false, message: error };
        }
      };
    };
    
    export const updateRuleRequest = (id, clientData) => ({
      type: actionTypes.UPDATE_RULE_REQUEST,
      payload: { id, clientData },
    });
    
    export const updateRuleSuccess = (message) => ({
      type: actionTypes.UPDATE_RULE_SUCCESS,
      payload: message,
    });
    
    export const updateRuleFailure = (error) => ({
      type: actionTypes.UPDATE_RULE_FAILURE,
      payload: error,
    });
    
    export const updateRuleById = (id, salaryData) => {
      return async (dispatch) => {
        const user = JSON.parse(sessionStorage.getItem('user'));
        salaryData.updated_by = user.user_name;
    
        dispatch(updateRuleRequest(id, salaryData));
        try {
          const response = await api.updateRule(id, salaryData);
          dispatch(updateRuleSuccess(response.message));
          return { success: true, message: response.message };
        } catch (error) {
          dispatch(updateRuleFailure(error));
          return { success: false, message: error };
        }
      };
    };
    export const deleteRuleRequest = (id) => ({
      type: actionTypes.DELETE_RULE_REQUEST,
      payload: id,
    });
    
    export const deleteRuleSuccess = (message) => ({
      type: actionTypes.DELETE_RULE_SUCCESS,
      payload: message,
    });
    
    export const deleteRuleFailure = (error) => ({
      type: actionTypes.DELETE_RULE_FAILURE,
      payload: error,
    });
    
    export const deleteRuleById = (id) => {
      return async (dispatch) => {
        dispatch(deleteRuleRequest(id));
        try {
          const response = await api.deleteRule(id);
          dispatch(deleteRuleSuccess(response.message));
          return { success: true, message: response.message };
        } catch (error) {
          dispatch(deleteRuleFailure(error));
          return { success: false, message: error };
        }
      };
    };


    export const uploadActivityRequest = (fileData) => ({
      type: actionTypes.UPLOAD_ACTIVITY_REQUEST,
      payload: fileData,
    });
    
    export const uploadActivitySuccess = (fileData) => ({
      type: actionTypes.UPLOAD_ACTIVITY_SUCCESS,
      payload: fileData,
    });
    
    export const uploadActivityFailure = (error) => ({
      type: actionTypes.UPLOAD_ACTIVITY_FAILURE,
      payload: error,
    });
    
    export const uploadActivityFile = (fileData) => {
      return async (dispatch) => {
        dispatch(uploadActivityRequest(fileData));
        try {
          const response = await api.uploadActivity(fileData);
          dispatch(uploadActivitySuccess(response));
          return { success: true, data: response };
        } catch (error) {
          dispatch(uploadActivityFailure(error));
          const errorMessage = error?.response?.data?.error || error?.message || 'Upload failed';
          return { success: false, error: errorMessage };
        }
      };
    };
    export const multiDaleteActivityRequest = (ids) => ({
      type: actionTypes.MULTIDELETE_ACTIVITY_REQUEST,
      payload: ids,
    });
    
    export const multiDaleteActivitySuccess = (message) => ({
      type: actionTypes.MULTIDELETE_ACTIVITY_SUCCESS,
      payload: message,
    });
    
    export const multiDaleteActivityFailure = (error) => ({
      type: actionTypes.MULTIDELETE_ACTIVITY_FAILURE,
      payload: error,
    });
    
    export const multiDeleteActivityFile = (ids) => {
      return async (dispatch) => {
        dispatch(multiDaleteActivityRequest(ids));
        try {
          const response = await api.multiDeleteActivity(ids);
          dispatch(multiDaleteActivitySuccess(response));
          return { success: true, message: response };
        } catch (error) {
          dispatch(multiDaleteActivityFailure(error));
          return { success: false, message: error };
        }
      };
    };
    
    
    export const getActivityRequest = () => ({
      type: actionTypes.GET_ACTIVITY_REQUEST,
    });
    
    export const getActivitySuccess = (clients) => ({
      type: actionTypes.GET_ACTIVITY_SUCCESS,
      payload: clients,
    });
    
    export const getActivityFailure = (error) => ({
      type: actionTypes.GET_ACTIVITY_FAILURE,
      payload: error,
    });
    
    export const getActivity = (current_month) => {
      return async (dispatch) => {
        dispatch(getActivityRequest());
        try {
          const response = await api.fetchActivity(current_month);
          dispatch(getActivitySuccess(response));
          return { success: true, data: response };
        } catch (error) {
          dispatch(getActivityFailure(error));
          return { success: false, message: error };
        }
      };
    };
    
    export const updateActivityRequest = (id, clientData) => ({
      type: actionTypes.UPDATE_ACTIVITY_REQUEST,
      payload: { id, clientData },
    });
    
    export const updateActivitySuccess = (message) => ({
      type: actionTypes.UPDATE_ACTIVITY_SUCCESS,
      payload: message,
    });
    
    export const updateActivityFailure = (error) => ({
      type: actionTypes.UPDATE_ACTIVITY_FAILURE,
      payload: error,
    });
    
    export const updateActivityById = (id, salaryData) => {
      return async (dispatch) => {
        const user = JSON.parse(sessionStorage.getItem('user'));
        salaryData.updated_by = user.user_name;
    
        dispatch(updateActivityRequest(id, salaryData));
        try {
          const response = await api.updateActivity(id, salaryData);
          dispatch(updateActivitySuccess(response.message));
          return { success: true, message: response.message };
        } catch (error) {
          dispatch(updateActivityFailure(error));
          return { success: false, message: error };
        }
      };
    };
    export const deleteActivityRequest = (id) => ({
      type: actionTypes.DELETE_ACTIVITY_REQUEST,
      payload: id,
    });
    
    export const deleteActivitySuccess = (message) => ({
      type: actionTypes.DELETE_ACTIVITY_SUCCESS,
      payload: message,
    });
    
    export const deleteActivityFailure = (error) => ({
      type: actionTypes.DELETE_ACTIVITY_FAILURE,
      payload: error,
    });
    
    export const deleteActivityById = (id) => {
      return async (dispatch) => {
        dispatch(deleteActivityRequest(id));
        try {
          const response = await api.deleteActivity(id);
          dispatch(deleteActivitySuccess(response.message));
          return { success: true, message: response.message };
        } catch (error) {
          dispatch(deleteActivityFailure(error));
          return { success: false, message: error };
        }
      };
    };


    export const createTemplateRequest = (Data) => ({
      type: actionTypes.UPLOAD_TEMPLATE_REQUEST,
      payload: Data,
    });
    
    export const createTemplateSuccess = (Data) => ({
      type: actionTypes.UPLOAD_TEMPLATE_SUCCESS,
      payload: Data,
    });
    
    export const createTemplateFailure = (error) => ({
      type: actionTypes.UPLOAD_TEMPLATE_FAILURE,
      payload: error,
    });
    
    export const createTemplate = (Data) => {
      return async (dispatch) => {
        dispatch(createTemplateRequest(Data));
        try {
          const response = await api.createTemplate(Data);
          dispatch(createTemplateSuccess(response));
          return { success: true, message: response };
        } catch (error) {
          dispatch(createTemplateFailure(error));
          return { success: false, message: error };
        }
      };
    };
    export const uploadTemplateRequest = (fileData) => ({
        type: actionTypes.UPLOAD_TEMPLATE_REQUEST,
        payload: fileData,
      });
      
      export const uploadTemplateSuccess = (fileData) => ({
        type: actionTypes.UPLOAD_TEMPLATE_SUCCESS,
        payload: fileData,
      });
      
      export const uploadTemplateFailure = (error) => ({
        type: actionTypes.UPLOAD_TEMPLATE_FAILURE,
        payload: error,
      });
      
      export const uploadTemplateFile = (fileData) => {
        return async (dispatch) => {
          dispatch(uploadTemplateRequest(fileData));
          try {
            const response = await api.uploadTemplate(fileData);
            dispatch(uploadTemplateSuccess(response));
            return { success: true, data: response };
          } catch (error) {
            dispatch(uploadTemplateFailure(error));
            const errorMessage = error?.response?.data?.error || error?.message || 'Upload failed';
            return { success: false, error: errorMessage };
          }
        };
      };
      export const multiDaleteTemplateRequest = (ids) => ({
        type: actionTypes.MULTIDELETE_TEMPLATE_REQUEST,
        payload: ids,
      });
      
      export const multiDaleteTemplateSuccess = (message) => ({
        type: actionTypes.MULTIDELETE_TEMPLATE_SUCCESS,
        payload: message,
      });
      
      export const multiDaleteTemplateFailure = (error) => ({
        type: actionTypes.MULTIDELETE_TEMPLATE_FAILURE,
        payload: error,
      });
      
      export const multiDeleteTemplateFile = (ids) => {
        return async (dispatch) => {
          dispatch(multiDaleteTemplateRequest(ids));
          try {
            const response = await api.multiDeleteTemplate(ids);
            dispatch(multiDaleteTemplateSuccess(response));
            return { success: true, message: response };
          } catch (error) {
            dispatch(multiDaleteTemplateFailure(error));
            return { success: false, message: error };
          }
        };
      };
      
      
      export const getTemplateRequest = () => ({
        type: actionTypes.GET_TEMPLATE_REQUEST,
      });
      
      export const getTemplateSuccess = (clients) => ({
        type: actionTypes.GET_TEMPLATE_SUCCESS,
        payload: clients,
      });
      
      export const getTemplateFailure = (error) => ({
        type: actionTypes.GET_TEMPLATE_FAILURE,
        payload: error,
      });
      
      export const getTemplate = () => {
        return async (dispatch) => {
          dispatch(getTemplateRequest());
          try {
            const response = await api.fetchTemplate();
            dispatch(getTemplateSuccess(response));
            return { success: true, data: response };
          } catch (error) {
            dispatch(getTemplateFailure(error));
            return { success: false, message: error };
          }
        };
      };
      
      export const updateTemplateRequest = (id, clientData) => ({
        type: actionTypes.UPDATE_TEMPLATE_REQUEST,
        payload: { id, clientData },
      });
      
      export const updateTemplateSuccess = (message) => ({
        type: actionTypes.UPDATE_TEMPLATE_SUCCESS,
        payload: message,
      });
      
      export const updateTemplateFailure = (error) => ({
        type: actionTypes.UPDATE_TEMPLATE_FAILURE,
        payload: error,
      });
      
      export const updateTemplateById = (id, salaryData) => {
        return async (dispatch) => {
          const user = JSON.parse(sessionStorage.getItem('user'));
          salaryData.updated_by = user.user_name;
      
          dispatch(updateTemplateRequest(id, salaryData));
          try {
            const response = await api.updateTemplate(id, salaryData);
            dispatch(updateTemplateSuccess(response.message));
            return { success: true, message: response.message };
          } catch (error) {
            dispatch(updateTemplateFailure(error));
            return { success: false, message: error };
          }
        };
      };
      export const deleteTemplateRequest = (id) => ({
        type: actionTypes.DELETE_TEMPLATE_REQUEST,
        payload: id,
      });
      
      export const deleteTemplateSuccess = (message) => ({
        type: actionTypes.DELETE_TEMPLATE_SUCCESS,
        payload: message,
      });
      
      export const deleteTemplateFailure = (error) => ({
        type: actionTypes.DELETE_TEMPLATE_FAILURE,
        payload: error,
      });
      
      export const deleteTemplateById = (id) => {
        return async (dispatch) => {
          dispatch(deleteTemplateRequest(id));
          try {
            const response = await api.deleteTemplate(id);
            dispatch(deleteTemplateSuccess(response.message));
            return { success: true, message: response.message };
          } catch (error) {
            dispatch(deleteTemplateFailure(error));
            return { success: false, message: error };
          }
        };
      };
  